import React from 'react';

import {
  RedirectAuthButton,
  type RedirectAuthButtonProps,
  type RedirectAuthProvider,
  type RedirectIntent,
} from '../oauth/RedirectAuthButton';
import { GoogleBrandIcon } from './GoogleBrandIcon';

/** @public */
export type GoogleRedirectIntent = RedirectIntent;
export type GoogleAuthRedirectButtonProps = RedirectAuthButtonProps;

const GOOGLE_PROVIDER: RedirectAuthProvider = {
  authPath: '/auth/google',
  authMethod: 3,
  providerName: 'Google',
  defaultLabel: 'Continue with Google',
  idPrefix: 'google',
  Icon: GoogleBrandIcon,
};

/**
 * Redirect-based Google auth button for the server-side OAuth flow.
 * Navigates to /auth/google — Rails handles the full OAuth exchange via OmniAuth.
 * No Google JavaScript SDK in the login path.
 */
export const GoogleAuthRedirectButton: React.FC<GoogleAuthRedirectButtonProps> = (props) => (
  <RedirectAuthButton {...props} provider={GOOGLE_PROVIDER} />
);
